import initBondCards from '../../scripts/initBondCards'

export default {
	data() {
		return {
			stockSwitchType: 'share',
			stockYear: 2021
		}
	},
	mounted() {
		initBondCards()
	}
}
